var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_321","data-name":"Group 321","transform":"translate(-1376 -5514)"},[React.createElement("circle",{"id":"Ellipse_5","data-name":"Ellipse 5","cx":"19.735","cy":"19.735","r":"19.735","transform":"translate(1376 5514)","fill":"#bcbcbc","key":0}),React.createElement("path",{"id":"Icon_awesome-linkedin-in","data-name":"Icon awesome-linkedin-in","d":"M4.667,20.85H.344V6.93H4.667ZM2.5,5.031A2.515,2.515,0,1,1,5.007,2.5,2.525,2.525,0,0,1,2.5,5.031ZM20.846,20.85H16.532V14.074c0-1.615-.033-3.686-2.247-3.686-2.247,0-2.592,1.755-2.592,3.57V20.85H7.375V6.93h4.146v1.9h.061a4.542,4.542,0,0,1,4.09-2.248c4.375,0,5.179,2.881,5.179,6.623V20.85Z","transform":"translate(1385 5522.999)","fill":"#fff","key":1})]));
}

LinkedinInline.defaultProps = {"width":"39.47","height":"39.47","viewBox":"0 0 39.47 39.47"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
